var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../shared/nunjucks.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./configure-pane-collapsible.html"] = require( "./configure-pane-collapsible.html" );




var shim = require("C:/Users/alejandro.lorenzo/Desktop/Projects/cloudmine-panel-core/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["templates/configure-pane-environments.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("./configure-pane-collapsible.html", true, "templates/configure-pane-environments.html", false, function(t_3,t_2) {
if(t_3) { cb(t_3); return; }
parentTemplate = t_2
for(var t_1 in parentTemplate.blocks) {
context.addBlock(t_1, parentTemplate.blocks[t_1]);
}
output += "\r\n\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("info"))(env, context, frame, runtime, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
output += t_4;
output += "\r\n\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("pane"))(env, context, frame, runtime, function(t_7,t_6) {
if(t_7) { cb(t_7); return; }
output += t_6;
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_info(env, context, frame, runtime, cb) {
var lineno = 2;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "\r\n";
output += runtime.suppressValue((lineno = 3, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "infoContent"), "infoContent", context, ["environments","Environments"])), env.opts.autoescape);
output += "\r\n";
output += runtime.suppressValue((lineno = 4, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "infoContent"), "infoContent", context, ["timeRange","Time interval"])), env.opts.autoescape);
output += "\r\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_pane(env, context, frame, runtime, cb) {
var lineno = 7;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "\r\n";
output += runtime.suppressValue((lineno = 8, colno = 12, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "component"), "component", context, ["environments","Environments"])), env.opts.autoescape);
output += "\r\n";
output += runtime.suppressValue((lineno = 9, colno = 12, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "component"), "component", context, ["timeRange","Time interval"])), env.opts.autoescape);
output += "\r\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_info: b_info,
b_pane: b_pane,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["templates/configure-pane-environments.html"] , dependencies)